<template>
    <div>
    <h2> Earth Shrine:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Earth Shrine')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/231749676/T46QvXr4SPFgGPNRlGJsHw/original.jpg?162518335755" target="_blank">Map</a><br/>
    The Earth Shrine is the easy difficulty encounter with a CR of 7 on floor 2. It is arena style, so monsters will spawn one after another.
    <v-row>
        <v-col>
            <img id="Earth Shrine" :src="require('../../../assets/Annotated_Earth_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place on the prime material plane.</li>
            <li>The area is covered in a thick fog, and players can only see 40 feet.</li>
            <li>The ceiling is an unmeasurable height, however if players ascend more than 40 feet they risk getting lost. If a player goes above 40 feet they must make a survival check each round DC 16+2 per 10 feet over 40 feet they are, +1 per round spent above 40 feet. If they fail they become lost, unable to act for 1d4 rounds, at which point they reappear 40 feet above a random area of the map.</li>
            <li>Map is 30x30</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Area Of Interest: Green</li>
                <li>Monster Spawns: Cyan</li>
                <li>Terrain of Note: White</li>
            </ul>                 
        </ul>
        <br/><br/>
        </v-col>
    </v-row>
    <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 7: </b> </li>
            First wave appears the moment players enter arena            
            <ul>
                <li><b>1) Large Earth Elemental CR 5: </b> Tunnels from the ground at spawnpoint 1, earthglides up to where players are.</li>
                <li><b>2) 2x Medium Earth Elemental CR 5:</b> Tunnels from the ground at spawnpoint 4, earthglides up to where players are.</li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 8: </b> </li>
            Wave 2 begins once both medium earth elementals are slain, or the large earth elemental.
            <ul>
                <li><b>1) Rock Troll CR 6: </b> walks in from spawnpoint 1 (alt 2,3) and attempts to climb the cliff to reach players</li>
                <li><b>2) 2x Gargoyle CR 4: </b> Flies in from spawnpoint 4, attempts to target any players off alone, or fight with rock troll </li>
            </ul>
            <br/>
            <li><b>Wave 3 CR 9: </b> </li>
            Wave 3 begins once rock troll or both gargoyles are dead.
            <ul>
                <li><b>1) Shaitan CR 7: </b> Tunnels in from spawnpoint 4 (alt 2, 3). First round Shiatan will cast stoneskin on themself, then earth glide to players.</li>
                <li><b>2) 2x Large Mud Elemental  CR 5: </b> enters from spawnpoint 1 (alt 2, 3)</li>
            </ul>
            <br/>
            <li><b>Wave 4 CR 11: </b> </li>
            Begins one full round after all monsters from wave 3 are dead.
            <ul>
                <li><b>2x 4 Armed Gargoyle CR 4: </b> appears flying from spawnpoint 1 and 4, (alt 2,3)</li>
            </ul>
            <br/>
            <li><b>Wave 5 CR 12: </b> </li>
            Wave 5 begins 3 full rounds after the first 4 Armed Gargoyle is slain.
            <ul>
                <li><b>Earth Ossumental CR 12: </b>Appears from furthest spawn point from players.</li>                
            </ul>
        </ul>
        <br/><br/>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Typed Spell/Maneuver 60</b></li>
            <li><b>2) 2-4 Potions 25</b></li>
            <li><b>3) Perk 125: </b> This perk is 20 feet up in a tree and requires a DC 15 climb check to get to.</li>
            <li><b>4) Spell/Maneuver 40</b></li>
            <li><b>5) Stats 50</b></li>
            <li><b>6) Spell/Maneuver 40</b></li>
            <li><b>7) 2-4 Potions 25</b></li>
            <li><b>8) Weapon Enchantment 100</b></li>
            <li><b>9) Typed Armor 25</b></li>
            <li><b>10) R+ Enchanted Armor 100</b></li>
            <li><b>11) Feat 125</b></li>
            <li><b>12) 2-4 Potions</b></li>
            <li><b>13) Stats 25</b></li>
            <li><b>14) R+ Enchanted R+ Weapon 125</b></li>
            <li><b>15) Stats 50</b></li>
            <li><b>16) Feat 125: </b> This feat is burried underground and requires a DC 18 perception check to notice, and a standard action to dig up.</li>
            <li><b>L1) Large Gold Pile: </b> This gold pile is 40 feet up a tree and requires 2 DC 20 climb checks to collect.</li>
            <li><b>L2) Large Gold Pile: </b>This gold pile is wrapped in poisonous brambles and requires a DC 23 knowledge nature or survival check to notice. They can be cut away easily with a standard action, but if collected before poison is noticed then collector must make a fortitude save DC 17 or receive 1d2 dex damage for 3 rounds. Players can reattempt save every round.</li>
            <li><b>C) R+ Typed Perk Cursed Chest: </b> If players activate cursed chest it spawns a Forgefiend(Scanderig), and rewards a R+ Typed Perk if it is defeated.</li>
        </ul>
        <br/><br/>

        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Earth Ritual: </b> The labelled rocks can be used for a ritual to gain bounties from the earth. Select 6 of the 8 pillars at random and decide on an order they must be activated in. Players must activate the stones in order to complete the ritual. When players enter the map they can immediately make a DC 18 knowledge nature, or dc 23 knowledge arcana check, if they succeed the are aware that these rocks can be used for this ritual. If they succeed the DC by 4 or more they immediately know which stone is first in the ritual. A player can attempt to learn what order a specific stone is by standing adjacent to it, and making a knowledge check as a movement action. The DCs are: 18 knowledge nature, or 23 knowledge arcana. Each time they succeed the check as part of the same movement action they can activate it. If they choose not to activate it when they succeed the check any player can come back and activate it as a movement action that requires no check. Once a stone is activated and specific treasure spawns adjacent to the activated stone in this order:
            <ul>
                <li>1) small gold pile, R+ stats 50</li>
                <li>2) small gold pile, Lvl++ Buff Spell 60</li>
                <li>3) small gold pile, Utility Perk 100</li>
                <li>4) small gold pile, Feat 100</li>
                <li>5) small gold pile, L+ stats 100</li>
                <li>6) small gold pile, Metamagic Feat 125</li>
            </ul>
            Once all stones are activated treasure appears in the center area: 
            <ul>
                <li>Large Gold Pile</li>
                <li>Level Up 200</li>
                <li>4-8 Typed potions 50</li>
                <li>E+ Perk 150</li>
                <li>E+ Stats 50</li>
                <li>E+ Stats 50</li>
            </ul>

            </li>            
        </ul>
        <br/><br/>

        <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Center Platform: </b> The Center area rises 40 feet above the ground.</li>            
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>